import React, { useState, useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Modal, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./State.css";
import { logActivity } from "../../utils/LogActivity";
import { AuthContext } from "../../Context/AuthContext";
import { Authorization } from "../../Context/Authorization";

const AddStateForm = ({ onClose, onAddState }) => {
  const [stateName, setStateName] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const { userId } = useContext(AuthContext);

  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!stateName) {
      newErrors.stateName = "State name is required";
    }
    if (!stateCode) {
      newErrors.stateCode = "State code is required";
    } else if (stateCode.length !== 2) {
      newErrors.stateCode = "State code must be 2 characters long";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitMessage("State added Successfully!");

    const formData = {
      stateName,
      stateCode,
    };

    try {
      const config = Authorization();

      const response = await fetch(`${Api}/api/states `, config, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Added Successfully");
        onAddState(result);
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
    await logActivity(userId, "Viewed State", "State Page", Api);
  };

  return (
    <div className="stateForm">
      <Modal show onHide={onClose}>
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}

        <Modal.Header>
          <Modal.Title>Add State</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formStateName">
              <Form.Label>
                State Name
                <span className="required-asterisk">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter state name"
                value={stateName}
                onChange={(e) => setStateName(e.target.value)}
                isInvalid={!!errors.stateName}
              />

              <Form.Control.Feedback type="invalid">
                {errors.stateName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formStateCode">
              <Form.Label>
                State Code
                <span className="required-asterisk">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter state code"
                value={stateCode}
                onChange={(e) => setStateCode(e.target.value)}
                isInvalid={!!errors.stateCode}
              />

              <Form.Control.Feedback type="invalid">
                {errors.stateCode}
              </Form.Control.Feedback>
            </Form.Group>

            <button
              type="submit"
              className="btn btn-outline-primary btn-icon-text mt-3"
            >
              <i className="mdi mdi-file-check btn-icon-prepend"></i>
              Submit
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddStateForm;
